// Modèle de données pour les réparations et maintenance

export interface Maintenance {
  id: number;
  reference: string;
  propertyId: number;
  propertyReference?: string;
  propertyTitle?: string;
  
  // Informations de la maintenance
  type: MaintenanceType; // 'reparation' | 'entretien' | 'renovation' | 'inspection' | 'urgence'
  category: string; // 'plomberie' | 'electricite' | 'chauffage' | 'toiture' | 'peinture' | 'autre'
  title: string;
  description: string;
  
  // Dates
  requestDate: Date;
  scheduledDate?: Date;
  completionDate?: Date;
  dueDate?: Date; // Date limite pour les réparations urgentes
  
  // Statut
  status: MaintenanceStatus; // 'demande' | 'planifiee' | 'en_cours' | 'terminee' | 'annulee' | 'reportee'
  priority: Priority; // 'basse' | 'normale' | 'haute' | 'urgence'
  
  // Prestataire
  providerId?: number;
  providerName?: string;
  providerPhone?: string;
  providerEmail?: string;
  
  // Coûts
  estimatedCost?: number;
  actualCost?: number;
  laborCost?: number;
  materialCost?: number;
  
  // Documents et photos
  photos?: string[];
  documents?: MaintenanceDocument[];
  invoiceUrl?: string;
  
  // Notes
  notes?: string;
  internalNotes?: string; // Notes internes non visibles par le locataire
  
  // Métadonnées
  createdAt: Date;
  updatedAt: Date;
  createdBy?: number;
  updatedBy?: number;
  
  // Suivi
  followUpDate?: Date;
  followUpNotes?: string;
}

export type MaintenanceType = 'reparation' | 'entretien' | 'renovation' | 'inspection' | 'urgence' | 'maintenance_preventive';
export type MaintenanceStatus = 'demande' | 'planifiee' | 'en_cours' | 'terminee' | 'annulee' | 'reportee' | 'en_attente_fournisseur';
export type Priority = 'basse' | 'normale' | 'haute' | 'urgence';

export interface MaintenanceDocument {
  id: number;
  type: string; // 'devis' | 'facture' | 'photo_avant' | 'photo_apres' | 'autre'
  name: string;
  url: string;
  uploadDate: Date;
}

// Exemple de données
export const SAMPLE_MAINTENANCES: Maintenance[] = [
  {
    id: 1,
    reference: 'MAINT-2024-001',
    propertyId: 1,
    propertyReference: 'APT-2024-001',
    propertyTitle: 'Appartement moderne 3 pièces',
    type: 'reparation',
    category: 'plomberie',
    title: 'Fuite robinet cuisine',
    description: 'Fuite importante au niveau du robinet de la cuisine',
    requestDate: new Date('2024-01-15'),
    scheduledDate: new Date('2024-01-16'),
    completionDate: new Date('2024-01-16'),
    status: 'terminee',
    priority: 'haute',
    providerName: 'Plomberie Express',
    providerPhone: '+33123456789',
    estimatedCost: 150,
    actualCost: 145,
    laborCost: 100,
    materialCost: 45,
    createdAt: new Date('2024-01-15'),
    updatedAt: new Date('2024-01-16')
  },
  {
    id: 2,
    reference: 'MAINT-2024-002',
    propertyId: 2,
    propertyReference: 'MAI-2024-002',
    propertyTitle: 'Villa avec jardin et piscine',
    type: 'entretien',
    category: 'autre',
    title: 'Entretien piscine mensuel',
    description: 'Nettoyage et traitement de l\'eau de la piscine',
    requestDate: new Date('2024-02-01'),
    scheduledDate: new Date('2024-02-05'),
    status: 'planifiee',
    priority: 'normale',
    providerName: 'Piscines & Co',
    estimatedCost: 200,
    createdAt: new Date('2024-02-01'),
    updatedAt: new Date('2024-02-01')
  }
];

